import React, { Component } from "react";
import { Formik, FieldArray } from "formik";
import filesize from "filesize";
import map from "lodash.map";
import Form from "react-bootstrap/lib/Form";
import { ProjectType } from "../../../utils/enums";
import { dayFormat } from "../../../utils/date";
import { ButtonLoader } from "../../ButtonLoader";
import { Button } from "../../Button";
import { ConsultationCategoryContainer } from "./ConsultationCategoryContainer";
import { Attachment } from "../../Attachment";

export default class ProjectListSurveyItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agreementAccepted: props.agreementAccepted || false,
    };
  }
  componentDidUpdate(prevProps) {
    if (prevProps.agreementAccepted !== this.props.agreementAccepted) {
      this.setState({
        agreementAccepted: this.props.agreementAccepted,
      });
    }
  }

  renderAttachmentsIcon(type) {
    switch (type) {
      case "application/pdf": {
        return (
          <i className="fas fa-file-pdf attachments-list__icon attachments-list__icon--primary-dark" />
        );
      }
      default: {
        return (
          <i className="fas fa-file attachments-list__icon attachments-list__icon--primary-dark" />
        );
      }
    }
  }
  render() {
    let { agreementAccepted: stateAgreementAccepted } = this.state;

    const {
      id,
      title = "",
      description = "",
      dateFrom = new Date(),
      dateTo = new Date(),
      modeName = "",
      onlyForLegalAge = false,
      isVoted = false,
      isOnlyOneOffice = true,
      officeName = "",
      isAuth = false,
      consultationFormValidationSchema,
      prefixName,
      type,
      disabled,
      voted,
      outOfRangeVoteDates,
      outOfRangeDistricts,
      index,
      isResultPublished,
      loggedUserId,
      attachments,
      resultAttachments,
      isVoteButtonEnabled,
      isExecuting,
      consultationForms,
      onSaveProjectVote,
      agreementAcceptedRequired = false,
      agreementAccepted = false,
      projectType = ProjectType.Survey,
      scrollToAgreement = Function.prototype,
    } = this.props;

    const consultationForm =
      consultationForms && consultationForms[0]
        ? consultationForms[0]
        : undefined;

    return (
      <div className="consultation-item">
        <div className="consultation-item__header">{title}</div>
        {
          // <div className="consultation-item__body">
        }
        <Formik
          // enableReinitialize={stateAgreementAccepted === agreementAccepted}
          initialValues={consultationForm}
          validationSchema={consultationFormValidationSchema}
          render={({
            touched,
            values,
            handleChange,
            handleBlur,
            isValid,
            errors,
            setFieldValue,
            isSubmitting,
            setSubmitting,
          }) => (
            <Form
              noValidate
              method="post"
              onSubmit={(e) => {
                e.preventDefault();
                if (
                  !stateAgreementAccepted &&
                  agreementAcceptedRequired &&
                  (projectType === ProjectType.Consultation ||
                    projectType === ProjectType.PublicBudget)
                ) {
                  scrollToAgreement();
                } else {
                  setSubmitting(true);
                  const newValues = {
                    ...values,
                    agreementAccepted: stateAgreementAccepted,
                  };
                  onSaveProjectVote(id, [newValues]);
                  setSubmitting(false);
                }
              }}
            >
              {typeof errors.maxPoint === "string" && (
                <Form.Control.Feedback
                  type="invalid"
                  style={{ display: "block", color: "red", marginTop: 10 }}
                >
                  {errors.maxPoint}
                </Form.Control.Feedback>
              )}
              <FieldArray
                id={`${prefixName}categories`}
                name={`${prefixName}categories`}
                render={(arrayHelper) => (
                  <ConsultationCategoryContainer
                    items={values.categories}
                    consultationFormType={type}
                    disabled={
                      disabled ||
                      isResultPublished ||
                      voted ||
                      outOfRangeVoteDates ||
                      outOfRangeDistricts ||
                      !isVoteButtonEnabled
                    }
                    prefixName={``}
                    isResultPublished={isResultPublished}
                    loggedUserId={loggedUserId}
                    projectType={projectType}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    setFieldValue={setFieldValue}
                    errors={errors}
                    isPreview={this.props.isPreview}
                  />
                )}
              />
              {attachments && attachments.length > 0 && (
                <React.Fragment>
                  <div className="consultations__title margin-top-25 margin-bottom-15">
                    Załączniki
                  </div>
                  <div className="attachments-list">
                    {map(attachments, (attachment) => (
                      <Attachment
                        key={attachment.id}
                        {...{
                          attachment,
                          url: `/api/attachments/${attachment.id}`,
                        }}
                      >
                        {this.renderAttachmentsIcon(attachment.contentType)}
                      </Attachment>
                    ))}
                  </div>
                </React.Fragment>
              )}
              {resultAttachments && resultAttachments.length > 0 && (
                <React.Fragment>
                  <div className="consultations__title margin-top-25 margin-bottom-15">
                    Załączniki
                  </div>
                  <div className="attachments-list">
                    {map(resultAttachments, (attachment) => (
                      <Attachment
                        key={attachment.id}
                        {...{
                          attachment,
                          url: attachment.isAct
                            ? `/api/actAttachments/${attachment.id}`
                            : `/api/attachments/${attachment.id}`,
                        }}
                      >
                        {this.renderAttachmentsIcon(attachment.contentType)}
                      </Attachment>
                    ))}
                  </div>
                </React.Fragment>
              )}
              <div
                className={`consultations__buttons margin-top-20 consultations__buttons--right margin-bottom-20`}
              >
                {isVoteButtonEnabled && isExecuting && (
                  <ButtonLoader
                    variant="danger"
                    disabled={isExecuting}
                    isExecuting={isExecuting}
                    executingText={"Zapisywanie"}
                  />
                )}
                {isVoteButtonEnabled && !isExecuting && (
                  <div className="button-container">
                    <Button
                      disabled={
                        !isValid ||
                        isSubmitting ||
                        (!stateAgreementAccepted &&
                          agreementAcceptedRequired &&
                          projectType !== ProjectType.Consultation &&
                          projectType !== ProjectType.PublicBudget)
                      }
                    >
                      Zagłosuj
                    </Button>
                  </div>
                )}
              </div>
            </Form>
          )}
        />
        {
          // </div>
        }
        <div className="consultation-item__footer">
          <div className="consultation-item__infos">
            <div className="consultation-item__info">
              <div className="consultation-item__info-label">
                Czas trwania od:{" "}
              </div>
              <div className="consultation-item__info-value">{`${dayFormat(
                dateFrom
              )}`}</div>
              <div className="consultation-item__info-label"> do: </div>
              <div className="consultation-item__info-value">{`${dayFormat(
                dateTo
              )}`}</div>
            </div>
            <div className="consultation-item__info">
              <div className="consultation-item__info-label">Tryb:</div>
              <div className="consultation-item__info-value">{modeName}</div>
            </div>
            <div className="consultation-item__info">
              <div className="consultation-item__info-label">
                Tylko dla pełnoletnich:
              </div>
              <div className="consultation-item__info-value">
                {onlyForLegalAge ? "Tak" : "Nie"}
              </div>
            </div>
            {isAuth && (
              <div className="consultation-item__info">
                <div className="consultation-item__info-label">
                  Oddany głos:
                </div>
                <div className="consultation-item__info-value">
                  {voted ? "Tak" : "Nie"}
                </div>
              </div>
            )}
            {!isOnlyOneOffice && (
              <div className="consultation-item__info">
                <div className="consultation-item__info-label">Jednostka: </div>
                <div className="consultation-item__info-value">
                  {officeName}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
